export default {
    courses: 'Basiskurse',
    finalquiz: 'Abschlusstests',
    back_to_menu: 'Zurück zu den Kursen',
    home: 'Startseite',
    new_chapter: 'neues Kapitel',
    new_chapter_plural: 'neue Kapitel'
}
